import { useEffect, useState } from 'react';

import { PreferredRetailer } from '@/components/atomic/templates/navigation/preferred-retailer/typings.ts';
import useDxUserPreferences from '@/hooks/use-dx-user-preferences/use-dx-user-preferences.ts';
import useStore from '@/state';
import getBrand from '@/state/selectors/brand/get-brand.ts';
import getLocale from '@/state/selectors/navigation/get-locale.ts';

const usePreferredRetailer = (dealerUrl?: string) => {
	const userPreferences = useDxUserPreferences();
	const [hasPreferredRetailer, setHasPreferredRetailer] = useState<boolean>(
		!!userPreferences?.preferred?.ciCode,
	);
	const [preferredRetailer, setPreferredRetailer] =
		useState<PreferredRetailer | null>(null);
	const brand = useStore(getBrand);
	const locale = useStore(getLocale);

	useEffect(() => {
		setHasPreferredRetailer(!!userPreferences?.preferred?.ciCode);
		setPreferredRetailer(null);

		if (!dealerUrl || !userPreferences?.preferred?.ciCode) {
			return;
		}

		const url = new URL(dealerUrl);
		url.searchParams.set('dealerCiCode', userPreferences?.preferred.ciCode);
		url.searchParams.set('requestMarketLocale', locale!);
		url.searchParams.set('unitOfMeasure', 'Miles');
		url.searchParams.set(
			'brand',
			brand === 'landrover' ? 'Land Rover' : 'Jaguar',
		);
		url.searchParams.set('radius', '0');
		url.searchParams.set('filter', 'dealer');

		(async () => {
			try {
				const res = await fetch(url);
				const json = await res.json();
				if (json.dealers?.length > 0) {
					setPreferredRetailer(json.dealers[0]);
				} else {
					throw new Error('No dealers found');
				}
			} catch (error) {
				console.error('Error fetching preferred retailer: ', error);
			}
		})();
	}, [userPreferences?.preferred?.ciCode]);

	return { hasPreferredRetailer, preferredRetailer };
};

export default usePreferredRetailer;
